<script lang="ts">
  import Stack from "../Stack.svelte";
  import TextNew from "../TextNew.svelte";

  export let title: string;
  export let subtitle: string = "";
  export let subtitleDetail: string | undefined = undefined;
  export let alignItems = "flex-start";
</script>

<div class="container" class:multi-line={subtitleDetail} style="align-items: {alignItems}">
  <TextNew size="s" --rk-text-color="var(--rk-text-transparency-dark)">{title}</TextNew>
  <div class="subtitle">
    <Stack vertical alignItems="flex-end">
      <TextNew size="s">{subtitle}</TextNew>
      {#if subtitleDetail}
        <TextNew size="s" --rk-text-color="var(--rk-text-transparency-dark)"
          >{subtitleDetail}</TextNew
        >
      {/if}
    </Stack>
  </div>
</div>

<style>
  .container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: solid 1px var(--rk-divider-0);
    gap: 32px;
  }

  .multi-line {
    padding: 8px 0;
  }

  .subtitle {
    text-align: right;
  }
</style>
